import { PropTypes } from 'imports';
import { ReactElement, ReactNode } from 'react';
import { ComponentEventHandler, ComponentEventHandler1, PureComponent, ReactEventHandler, ReactEventHandler1 } from 'typed/components/utils';
import PeriodCalendar, { Props as PeriodCalendarProps, PeriodType, periodTypePropType } from '../PeriodCalendar/PeriodCalendar';
import FormattedResource, { Resource, resourcePropType } from '../FormattedResource/FormattedResource';
import DropPanel from 'components/common/DropPanel/DropPanel';
import TimeStamp from 'components/common/TimeStamp/TimeStamp';
import withDateLocaleUtils, { dateLocaleUtilsPropTypes } from 'components/common/withDateLocaleUtils/withDateLocaleUtils';
import { Period } from 'typed/utils';

import './PeriodSelect.less';

export { PeriodType, periodTypePropType };

interface Props extends PeriodCalendarProps {
    inline?: boolean;
    placeholder?: Resource;
    clearable?: boolean;
    title?: ReactElement | Resource;
    onChange?: ComponentEventHandler1<Period | null>;
}

interface State {
    opened: boolean;
}

class PeriodSelect extends PureComponent<Props, State> {
    static readonly PeriodType = PeriodType;

    static readonly periodTypePropType = periodTypePropType;

    static readonly propTypes = {
        ...PeriodCalendar.propTypes,

        inline: PropTypes.bool,
        placeholder: resourcePropType,
        clearable: PropTypes.bool,
        title: PropTypes.oneOfType([resourcePropType, PropTypes.element]),
        onChange: PropTypes.func,

        ...dateLocaleUtilsPropTypes
    };

    static readonly defaultProps = {
        ...PeriodCalendar.defaultProps,
        clearable: false
    };

    state: State = { opened: false };

    private _onOpen: ComponentEventHandler = () => {
        this.setState({ opened: true });
    };

    private _onClose: ComponentEventHandler = () => {
        this.setState({ opened: false });
    };

    private _onClearClick: ReactEventHandler = (event) => {
        event.stopPropagation();
        this._onChange(this, null);
    };

    private _onChangeBy: ReactEventHandler1<number> = (delta) => {
        this._onChange(this, this.props.value!.add(delta));
    };

    private _onChange: ComponentEventHandler1<Period | null> = (_sender, value) => {
        if (this.props.onChange) {
            this.props.onChange(this, value);
        }

        this._onClose(this);
    };

    private _renderTitle(): ReactNode {
        const { placeholder, value, title } = this.props;

        if (title) {
            return title;
        }

        return (
            <div className="flex-row">
                <div className="main-col">
                    {
                        value ?
                            <TimeStamp detalizationPeriodType={value.type} exactDatePeriodType={null} value={value} /> :
                            <FormattedResource className="placeholder" resource={placeholder !== undefined ? placeholder : this.props.getDateFormat!()} />
                    }
                </div>

                {
                    this.props.clearable && !this.props.inline && value ?
                        <div className="buttons">
                            <button className="inline fa fa-times" onClick={this._onClearClick} />
                        </div> :
                        null
                }
            </div>
        );
    }

    render() {
        const { inline, value, minDate, maxDate, disabled, className } = this.props;

        return (
            <div className={`period-select ${inline ? 'inline ' : ''}${className}`}>
                {inline ? <button className="inline fa fa-chevron-left" disabled={!value || minDate && value.add(-1).start < minDate} onClick={this._onChangeBy.bind(this, -1)} /> : null}
                <DropPanel
                    ref="drop-panel"
                    className="period-select-drop-panel"
                    title={this._renderTitle()}
                    icon={!inline ? 'calendar' : null}
                    disabled={disabled}
                    opened={!!this.state.opened}
                    onOpen={this._onOpen}
                    onClose={this._onClose}
                >
                    <PeriodCalendar {...this.props} onChange={this._onChange} />
                </DropPanel>
                {
                    inline ?
                        <button className="inline fa fa-chevron-right" disabled={!value || !!maxDate && value.add(1).end >= maxDate} onClick={this._onChangeBy.bind(this, 1)} /> :
                        null
                }
            </div>
        );
    }
}

export default withDateLocaleUtils(PeriodSelect) as typeof PeriodSelect;
